import { Card } from '@/components/ui'
import { ReactNode } from 'react'

interface StatCardProps {
  icon: ReactNode
  count: number
  label: string
  colorScheme: 'blue' | 'green' | 'yellow'
}

const colorSchemes = {
  blue: {
    card: 'bg-blue-50',
    iconBg: 'bg-blue-100',
  },
  green: {
    card: 'bg-green-50',
    iconBg: 'bg-green-100',
  },
  yellow: {
    card: 'bg-yellow-50',
    iconBg: 'bg-yellow-100',
  },
}

export function StatCard({ icon, count, label, colorScheme }: StatCardProps) {
  const colors = colorSchemes[colorScheme]

  return (
    <Card className={`${colors.card} border-0`}>
      <div className="flex items-center">
        <div className={`w-10 h-10 rounded-full ${colors.iconBg} flex items-center justify-center mr-3`}>
          {icon}
        </div>
        <div>
          <div className="text-xl font-bold">{count.toLocaleString()}</div>
          <div className="text-gray-500">{label}</div>
        </div>
      </div>
    </Card>
  )
}

